module.exports = __webpack_public_path__ + "img/time.35111861.svg";